
import { Component, Vue } from 'vue-property-decorator';
import { Iter } from '@/types';

@Component
export default class UtilsMixin extends Vue {
  iterValues = [
    {
      text: 'Ordinario',
      value: 'o',
    },
    {
      text: 'Semplificato',
      value: 's',
    },
    {
      text: 'Superbonus 110% - Ordinario',
      value: 'bo',
    },
    {
      text: 'Superbonus 110% - Semplificato',
      value: 'bs',
    },
    {
      text: 'Superbonus 110%',
      value: 'b',
    },
    {
      text: 'Pre Check Connessione',
      value: 'ps',
    },
    {
      text: 'Non applicabile',
      value: 'n',
    },
  ]

  iterTypeValues = [
    {
      text: 'Nuovo impianto',
      value: 'new',
    },
    {
      text: 'Ampliamento',
      value: 'upgrade',
    },
    {
      text: 'Installazione batteria',
      value: 'battery',
    },
  ]

  iterTitle(iter: Iter | null): string {
    if (iter === 'o') return 'O';
    if (iter === 's') return 'S';
    if (iter === 'bo') return 'Bo';
    if (iter === 'bs') return 'Bs';
    if (iter === 'b') return 'B';
    if (iter === 'ps') return 'Ps';
    if (iter === 'n') return 'N';
    return '';
  }

  iterDescription(iter: Iter | null): string {
    if (!iter) return 'Non selezionato';

    return this.iterValues.find((i) => i.value === iter)?.text ?? '';
  }
}
